import type { TeamPublic } from '../types/arena';

const safeNumber = (value: unknown, fallback = 0) => (typeof value === 'number' && Number.isFinite(value) ? value : fallback);

export function averageAnswerMs(team: TeamPublic): number {
  const submitted = Math.max(1, safeNumber(team.submittedCount, team.correctCount || 1));
  return safeNumber(team.totalAnswerMs) / submitted;
}

export function formatDuration(ms: number | null | undefined): string {
  if (typeof ms !== 'number' || !Number.isFinite(ms) || ms <= 0) return '—';
  if (ms < 1000) return `${Math.round(ms).toLocaleString('fa-IR')} ms`;
  const seconds = ms / 1000;
  if (seconds < 60) return `${seconds.toLocaleString('fa-IR', { maximumFractionDigits: 1 })} ثانیه`;
  const minutes = Math.floor(seconds / 60);
  const rest = Math.round(seconds % 60);
  return `${minutes.toLocaleString('fa-IR')}:${String(rest).padStart(2, '0')}`;
}

export function teamPerformanceLabel(team: TeamPublic): string {
  const submitted = safeNumber(team.submittedCount, team.correctCount);
  if (!submitted) return 'در حال گرم‌کردن';
  const avgAnswer = averageAnswerMs(team);
  const accuracy = safeNumber(team.correctCount) / Math.max(1, submitted);

  if (avgAnswer <= 45_000) return 'برق‌آسا';
  if (safeNumber(team.bestStreak) >= 5) return 'زنجیره‌ساز';
  if (accuracy >= 0.8) return 'دقیق و کم‌خطا';
  if (safeNumber(team.hardCorrect) >= 2) return 'سخت‌کُش';
  return 'جنگنده میدان';
}
